(function () {
  var CURRENCY_KEY = 'em_currency';
  var RATE_KEY = 'em_eur_rate';
  var RATE_TTL = 6 * 60 * 60 * 1000; // 6 hours
  var FALLBACK_RATE = 7.46; // DKK per 1 EUR

  var dkkPerEur = FALLBACK_RATE;
  var active = localStorage.getItem(CURRENCY_KEY) || 'DKK';

  function loadCachedRate() {
    try {
      var data = JSON.parse(localStorage.getItem(RATE_KEY));
      if (data && Date.now() - data.ts < RATE_TTL) {
        dkkPerEur = data.rate;
        return true;
      }
    } catch (_) {}
    return false;
  }

  function fetchRate() {
    return fetch('https://cdn.jsdelivr.net/npm/@fawazahmed0/currency-api@latest/v1/currencies/eur.min.json')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (d.eur && d.eur.dkk) {
          dkkPerEur = d.eur.dkk;
          localStorage.setItem(RATE_KEY, JSON.stringify({ rate: dkkPerEur, ts: Date.now() }));
        }
      })
      .catch(function () {});
  }

  function formatPrice(cents, currency) {
    var amount = cents / 100;
    if (currency === 'EUR') {
      amount = Math.ceil(amount / dkkPerEur);
    } else {
      amount = Math.round(amount);
    }
    return amount.toLocaleString('da-DK', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }) + ' ' + currency;
  }

 function convertPrices(scope) {
  var root = scope || document;
  var containers = root.querySelectorAll('[data-price-cents]');
  for (var i = 0; i < containers.length; i++) {
    var el = containers[i];

    // Spring over priser inde i cart-drawer / cart-items — vis altid butikkens rigtige valuta der
    if (el.closest('cart-drawer-component, .cart-items-component')) {
      continue;
    }

    var priceCents = parseInt(el.getAttribute('data-price-cents'), 10);
    var compareCents = parseInt(el.getAttribute('data-compare-price-cents'), 10) || 0;
    var priceEl = el.querySelector('.price');
    var compareEl = el.querySelector('.compare-at-price');
    if (!isNaN(priceCents) && priceCents > 0) {
      if (priceEl) {
        priceEl.textContent = formatPrice(priceCents, active);
      } else {
        el.textContent = formatPrice(priceCents, active);
      }
    }
    if (compareEl && compareCents > 0) {
      compareEl.textContent = formatPrice(compareCents, active);
    }
  }
}

  function setCurrency(currency) {
    active = currency;
    localStorage.setItem(CURRENCY_KEY, currency);
    convertPrices();
    refreshUI();
  }

  function togglePanel() {
    var el = document.getElementById('em-cs');
    if (el) el.toggleAttribute('data-open');
  }

  var FLAGS = {
    DKK: { src: 'https://flagcdn.com/w40/dk.png', alt: 'DK' },
    EUR: { src: 'https://flagcdn.com/w40/eu.png', alt: 'EU' },
  };

  function refreshUI() {
    var btn = document.getElementById('em-cs-btn');
    if (!btn) return;
    var flagEl = document.getElementById('em-cs-flag-img');
    var codeEl = btn.querySelector('.em-cs-code');
    if (flagEl) {
      flagEl.src = FLAGS[active].src;
      flagEl.alt = FLAGS[active].alt;
    }
    if (codeEl) codeEl.textContent = active;

    var opts = document.querySelectorAll('[data-currency-select]');
    for (var i = 0; i < opts.length; i++) {
      if (opts[i].getAttribute('data-currency-select') === active) {
        opts[i].setAttribute('data-active', '');
      } else {
        opts[i].removeAttribute('data-active');
      }
    }
  }

  function init() {
    convertPrices();
    refreshUI();

    var btn = document.getElementById('em-cs-btn');
    if (btn) btn.addEventListener('click', togglePanel);

    var opts = document.querySelectorAll('[data-currency-select]');
    for (var i = 0; i < opts.length; i++) {
      (function (opt) {
        opt.addEventListener('click', function () {
          setCurrency(opt.getAttribute('data-currency-select'));
          var panel = document.getElementById('em-cs');
          if (panel) panel.removeAttribute('data-open');
        });
      })(opts[i]);
    }

    document.addEventListener('click', function (e) {
      var cs = document.getElementById('em-cs');
      if (cs && !cs.contains(e.target)) cs.removeAttribute('data-open');
    });

    // Re-convert when new price elements appear (variant switches, cart updates)
    var observer = new MutationObserver(function (mutations) {
      for (var m = 0; m < mutations.length; m++) {
        var added = mutations[m].addedNodes;
        for (var n = 0; n < added.length; n++) {
          var node = added[n];
          if (node.nodeType !== 1) continue;
          if (node.hasAttribute && node.hasAttribute('data-price-cents')) {
            convertPrices(node.parentElement);
          } else if (node.querySelector) {
            var found = node.querySelector('[data-price-cents]');
            if (found) convertPrices(node);
          }
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  function boot() {
    var rateReady = loadCachedRate();
    var ready = rateReady ? Promise.resolve() : fetchRate();
    ready.then(function () {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
      } else {
        init();
      }
    });
  }

  boot();
})();
